"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiStepIcon = function MuiStepIcon(theme) {
  return {
    root: {
      zIndex: 1,
      '&$completed': {
        color: theme.palette.success.main
      }
    },

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {}
  };
};

var _default = MuiStepIcon;
exports["default"] = _default;